import React, { useEffect, useRef, useState } from 'react';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import MonthlyInvoiceControl from './MonthlyInvoiceControl';
import {
  afterTabChange,
  initialInvoiceManagementTab,
  InvoiceManagementTab,
  openReceivedNotes,
  panelVisibility,
  ReceivedNotesFocus,
} from '../utils/invoiceManagementTabs';
import { HistoryTarget, ObligationPage } from '../utils/monthlyInvoiceView';

interface InvoiceManagementTabsProps {
  receivedNotes: React.ReactNode;
  loadPage?: (competence: string, page: number, limit: number) => Promise<ObligationPage>;
}

const InvoiceManagementTabs: React.FC<InvoiceManagementTabsProps> = ({ receivedNotes, loadPage }) => {
  const [tab, setTab] = useState<InvoiceManagementTab>(initialInvoiceManagementTab);
  const [focus, setFocus] = useState<ReceivedNotesFocus | null>(null);
  const receivedRef = useRef<HTMLDivElement | null>(null);
  const visible = panelVisibility(tab);

  useEffect(() => {
    if (tab === 'received' && focus) {
      receivedRef.current?.scrollIntoView({ block: 'nearest' });
    }
  }, [tab, focus]);

  const openReview = (target: HistoryTarget) => {
    setFocus(openReceivedNotes(target));
    setTab('received');
  };

  return (
    <Box>
      <Tabs
        value={tab}
        onChange={(_event, value: InvoiceManagementTab) => {
          setTab(afterTabChange(value));
        }}
        aria-label="Gestão de notas fiscais"
      >
        <Tab value="monthly" label="Controle mensal" />
        <Tab value="received" label="Notas recebidas" />
      </Tabs>
      <Box role="tabpanel" hidden={!visible.monthly} sx={{ pt: 2 }}>
        <MonthlyInvoiceControl loadPage={loadPage} onOpenHistory={openReview} />
      </Box>
      <Box
        role="tabpanel"
        id="invoice-received-panel"
        ref={receivedRef}
        hidden={!visible.received}
        sx={{ pt: 2 }}
      >
        {focus ? (
          <Alert severity="info" sx={{ mb: 2 }} onClose={() => setFocus(null)}>
            {focus.banner}
          </Alert>
        ) : null}
        {receivedNotes}
      </Box>
    </Box>
  );
};

export default InvoiceManagementTabs;
